import { render, staticRenderFns } from "./VipHeadMain.vue?vue&type=template&id=ab6cab26&scoped=true&lang=html"
import script from "./VipHeadMain.vue?vue&type=script&lang=js"
export * from "./VipHeadMain.vue?vue&type=script&lang=js"
import style0 from "./VipHeadMain.vue?vue&type=style&index=0&id=ab6cab26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6cab26",
  null
  
)

export default component.exports